import { render, staticRenderFns } from "./ExtendCourseDialog.vue?vue&type=template&id=5ef133d1&scoped=true"
import script from "./ExtendCourseDialog.vue?vue&type=script&lang=js"
export * from "./ExtendCourseDialog.vue?vue&type=script&lang=js"
import style0 from "./ExtendCourseDialog.vue?vue&type=style&index=0&id=5ef133d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef133d1",
  null
  
)

export default component.exports